import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sidebarOpen: true,
    sidebarCollapsed: false, // Icon-only mode
    mobileMenuOpen: false,
    theme: 'light',
    loading: false,
    activeModule: 'finans', // 'finans' | 'insaat'
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload;
        },
        toggleSidebarCollapse: (state) => {
            state.sidebarCollapsed = !state.sidebarCollapsed;
        },
        setSidebarCollapsed: (state, action) => {
            state.sidebarCollapsed = action.payload;
        },
        toggleMobileMenu: (state) => {
            state.mobileMenuOpen = !state.mobileMenuOpen;
        },
        setMobileMenuOpen: (state, action) => {
            state.mobileMenuOpen = action.payload;
        },
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        toggleTheme: (state) => {
            state.theme = state.theme === 'light' ? 'dark' : 'light';
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setActiveModule: (state, action) => {
            state.activeModule = action.payload;
        },
    },
});

export const {
    toggleSidebar,
    setSidebarOpen,
    toggleSidebarCollapse,
    setSidebarCollapsed,
    toggleMobileMenu,
    setMobileMenuOpen,
    setTheme,
    toggleTheme,
    setLoading,
    setActiveModule,
} = uiSlice.actions;

export default uiSlice.reducer;

